import React, {createContext, useCallback, useContext, useEffect, useRef, useState} from 'react';
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    InputAdornment,
    useMediaQuery,
} from '@material-ui/core';
import {CustomDialog, Loading, SwipeStyledButton, TextAlertDialog} from "@cabinet-packages/components/index";
import {getClientLocation, getPunkts, setOrderPunkt} from "@cabinet-packages/redux/actions/actionsCreators";
import {useDispatch, useSelector} from "react-redux";
import useStyles from './styles'
import {createFilterOptions} from "@material-ui/lab";
import {getRegions} from "@cabinet-packages/api/api";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import arrow from "../../../assets/images/map/arrow.png";
import Departure from "./components/Departure";
import OverlayView from "react-google-maps/lib/components/OverlayView";
import IconButton from "@material-ui/core/IconButton";
import {Close} from "@material-ui/icons";
import TablePoints from "./components/TablePoints";
import locationActive from "../../../assets/images/map/location_active.png";
import Location from "../../../assets/images/map/Location.png";
import {GoogleMap, withGoogleMap, withScriptjs} from "react-google-maps";

const MapContext = createContext(null);
const MapProvider = MapContext.Provider;
const googleApiKey = process.env.REACT_APP_GOOGLE_API_KEY;

const getPixelPositionOffset = (width, height) => ({
    x: -(width / 2),
    y: -height,
})

const EditDepartmentDialog = ({ order, punkt, handleClose }) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const googleMapStringURL = `https://maps.googleapis.com/maps/api/js?v=3.exp&key=${googleApiKey}&language=uk`;
    const mdUp = useMediaQuery(theme => theme.breakpoints.up('md'))

    const [selectedPoint, setSelectedPoint] = useState(null);
    const [isUserSelectPoint, setIsUserSelectPoint] = useState(false);
    const {clientLocation, punkts, regions, selectPunkt} = useSelector(store => store.collectionPoints);
    const {themeMaterialUI} = useSelector(store => store.theme);
    const [open, setOpen] = useState(false);
    const [openRegion, setOpenRegion] = useState(false);
    const [points, setPoints] = useState([])
    const [selectRegion, setSelectRegion] = useState('')
    const idReg = localStorage.getItem('idReg')
    const [checkboxState, setCheckboxState] = useState({});
    const [checkNearest, setCheckNearest] = useState({});
    const [valueCity, setValueCity] = useState('')
    const [valueStreet, setValueStreet] = useState('')
    const [state, setState] = useState({checkedC: false});

    const filteredOptions = createFilterOptions({
        limit: state.checkedC ? 100 : 20
    });

    const handleChangeAllPunkts = (event) => {
        event.persist();

        // if (event.target.checked) {
        //     handleClickOnPunktRegion(false, {idReg: 2, name: 'Львів'}, true);
        //     setSelectRegion('Львів');
        //     setValueStreet('')
        // } else {
        //     handleClickOnPunktRegion(false, {idReg, name: points.find(el => el.idReg == idReg)?.name}, true);
        //     setSelectRegion(points.find(el => el.idReg == idReg)?.name);
        //     setSelectedPoint(null);
        //     setValueStreet('')
        // }

        setState(prev => ({...prev, [event.target.name]: event.target.checked}));
    }

    const handleClickOnPunkt = (point, option) => {
        setSelectedPoint(point);
        setIsUserSelectPoint(true);
        dispatch(getClientLocation(point))
        setCheckNearest({...point, active: true});
        if (option) {
            setCheckboxState({})
        }
    };

    const handleClickOnPunktRegion = (event, value, dontCallAllPunkts) => {
        if (value && value.name === 'Усі пункти' && !dontCallAllPunkts) {
            handleChangeAllPunkts({
                persist: () => {},
                target: {
                    checked: true,
                    name: 'checkedC'
                }
            })
        } else if (value && value.idReg) {
            // setCheckNearest({})
            setValueCity(value.name);
            localStorage.setItem('idReg', value.idReg);
            dispatch(getClientLocation(null, true))
            setCheckboxState({});
            // handleChangeRegionPrice();
            setSelectedPoint(null);
            if (state.checkedC && !dontCallAllPunkts) {
                handleChangeAllPunkts({
                    persist: () => {
                    },
                    target: {
                        checked: false,
                        name: 'checkedC'
                    }
                })
            }
        }
    };

    const handleAddressClose = (reason) => {
        setOpen(false);
        if (reason === 'blur') setIsUserSelectPoint(false);
    };

    const handleCloserRegion = (reason) => {
        setOpenRegion(false)
    }

    const getClosestPunkt = useCallback(() => {
        if (!clientLocation) CustomDialog(TextAlertDialog, {
            text: `Будь ласка, дозвольте використання геолокації на вашому пристрої.`,
            onConfirm: () => {
            },
        }, false, themeMaterialUI);
        // if (punkts) setSelectedPoint(punkts[0]);
    }, [clientLocation, punkts]);

    useEffect(() => {
        dispatch(getPunkts(false, true));

        if (clientLocation && punkts && punkts.length > 0 && !isUserSelectPoint) getClosestPunkt();
        // if (punkts && punkts.length > 0 && !selectedPoint) setSelectedPoint(punkts[0]);
    }, [clientLocation, punkts, selectedPoint, dispatch, getClosestPunkt, isUserSelectPoint]);


    const resultRegion = async () => {
        const res = await getRegions()
        if (res) {
            setPoints(res.sort((a,b) => a.name.localeCompare(b.name)))
        }
    }

    useEffect(() => {
        if (points.length > 0 && points.find(el => el.idReg == idReg)?.name !== selectRegion) {

            setSelectRegion(points.find(el => el.idReg == idReg)?.name)
        }
    }, [points, idReg]);

    useEffect(() => {
        resultRegion()
    }, [])

    // useEffect(() => {
    //     dispatch(getClientLocation(punkt))
    //     setValueStreet(punkt?.address)
    //     setCheckNearest(punkt);
    // }, [])

    function cutWord(text, limit) {
        if (text === undefined) return;
        text = text.trim();
        if (text.length <= limit) return text;
        text = text.slice(0, limit);
        let lastSpace;
        lastSpace = text.lastIndexOf(" ");
        if (lastSpace > 0) {
            text = text.substr(0, lastSpace);
        }
        return text.includes('(') ? text + "...)" : text + "...";
    }

    const setOption = (el) => {
        if (selectRegion && el) {
            if (el.includes(selectRegion) && !state.checkedC) {
                return cutWord(el?.split(',').slice(1).join().trim(), 50)
            } else {
                return cutWord(el.trim(), 50)
            }
        }
    }

    const filterByOpt = () => {
        const arrayFiltered = Object.keys(checkboxState).filter((key) => checkboxState[key]);
        if (punkts) {
            const arrayCopy = state.checkedC ? [...punkts] : [...punkts].filter(el => +el.idCity === +idReg);
            if (arrayFiltered.length === 0) {
                return arrayCopy;
            }
            return arrayCopy.filter(punkt => arrayFiltered.filter(el => punkt.opt.includes(el)).length === arrayFiltered.length)
        }
    }

    const handleRegionEndAdornment = (item) => {
        if (item === 'openRegion') {
            setOpenRegion(true)
        }
        if (item === 'openStreet') {
            setOpen(true)
        }
    }

    useEffect(() => {
        if (points) {
            setValueCity(points.find(el => +el.idReg === selectPunkt.idCity)?.name)
        }
        if (punkts) {
            // const findSelektPunkt = filterByOpt().filter(el => +el.idCity === +idReg)[0]
            // dispatch(getClientLocation(findSelektPunkt))
            setCheckNearest(punkt);
        }
    }, [points, punkts])

    useEffect(() => {
        if (punkts && !selectPunkt){
            const  findStreetActive  = filterByOpt().find(el => +el.idCity === +idReg)
            setValueStreet(findStreetActive?.address)
            dispatch(getClientLocation(findStreetActive));
            setCheckNearest(findStreetActive);
        }
    },[valueStreet, punkts, idReg, selectPunkt]);

    useEffect(() => {
        if (selectPunkt?.address !== valueStreet?.address) {
            setValueStreet(selectPunkt?.address)
        }
    }, [selectPunkt]);


    const handleConfirm = () => {
        dispatch(setOrderPunkt(order.id, selectPunkt.idPunkt))
        handleClose()
    }

    return (
        <Dialog
            open={true}
            onClose={() => handleClose()}
            PaperProps={{
                style: { borderRadius: 10, maxWidth: '1100px', width: mdUp ? '800px' : '100%'}
            }}
        >
            <DialogTitle className={classes.dialogTitle}>
                РЕДАГУВАННЯ ВІДДІЛЕННЯ
            </DialogTitle>
            <DialogContent className={classes.dialogContent}>
                <Grid container spacing={2} className={classes.containerWrapper}>
                    <Grid item xs={mdUp ? 6 : 12}>
                        <div className={classes.inputWrapperRegion}>
                            <Autocomplete
                                autoComplete={false}
                                autoSelect={true}
                                key={'autocompleteShow' + state.checkedC}
                                className={classes.inputWrapperRegionRoot}
                                open={openRegion}
                                onOpen={() => setOpenRegion(true)}
                                onClose={(event, reason) => handleCloserRegion(reason)}
                                freeSolo
                                options={points ? points : []}
                                renderOption={(props) => <p className={classes.autoCompleteRegionOpthion}>{props.name}
                                    <span className={classes.autoCompleteRegionImgSelected}/></p>}
                                getOptionLabel={(option) => {
                                    return (option.name || option);
                                }}
                                onChange={(event, value) => handleClickOnPunktRegion(event, value)}
                                renderInput={(params) => <TextField {...params} InputProps={{
                                    ...params.InputProps,
                                    classes: {
                                        root: classes.autoCompleteRegion,
                                        input: classes.autoCompleteInput
                                    },
                                    autoComplete: 'off',
                                    endAdornment: (<InputAdornment
                                        position="end">
                                        <span onClick={() => handleRegionEndAdornment('openRegion')}
                                              className={classes.endAdornmentInput}>
                                        <img
                                            src={arrow} alt="arrow" className={classes.imgSelectPoint}/>
                                        </span>
                                    </InputAdornment>),

                                }} name="none" placeholder={valueCity} variant="outlined"/>}
                            />
                        </div>
                    </Grid>
                    <Grid item xs={mdUp ? 6 : 12}>
                        <div className={classes.wrapperStreetDesktop}>
                            <Autocomplete
                                autoComplete={false}
                                open={open}
                                key={valueStreet}
                                onOpen={() => handleRegionEndAdornment('openStreet')}
                                onClose={(event, reason) => handleAddressClose(reason)}
                                freeSolo
                                options={punkts
                                    ? punkts.filter(el => +el.idCity === +idReg)
                                    : []
                                }
                                filterOptions={filteredOptions}
                                getOptionLabel={(option) => setOption(option.address)}
                                onChange={(event, value) => handleClickOnPunkt(value, true)}
                                renderInput={(params) => <TextField {...params} InputProps={{
                                    classes: {
                                        root: classes.autoComplete,
                                        input: classes.autoCompleteInput
                                    },
                                    ...params.InputProps,
                                    autoComplete: 'off',
                                    endAdornment: <InputAdornment
                                        position="end">
                                            <span onClick={() => handleRegionEndAdornment('openStreet')}
                                                  className={classes.endAdornmentInput}>
                                            <img src={arrow} alt="arrow" className={classes.imgSelectPoint}/>
                                        </span>
                                    </InputAdornment>,
                                }} name="none" placeholder={valueStreet} variant="outlined"/>}
                            />
                        </div>
                    </Grid>
                    <Grid item xs={12}>
                        <MapProvider
                            value={{
                                punkt: selectedPoint,
                                lat: selectedPoint ? +selectedPoint.lat : punkts ? filterByOpt().length > 0 ? filterByOpt()[0].lat : punkts : 0,
                                lng: selectedPoint ? +selectedPoint.lng : punkts ? filterByOpt().length > 0 ? filterByOpt()[0].lng : punkts : 0,
                                markers: punkts ? filterByOpt() : [],
                                checkNearest: checkNearest,
                                selectedPoint: selectedPoint ? selectedPoint : {},
                                selectPunkt: selectPunkt,
                                isUserSelectPoint,
                                handleClickOnPunkt,
                                setCheckNearest,
                                inFrame: false,
                                showAllPunkts: state.checkedC,
                            }}>
                            <div className={classes.rootPoints}>
                                <div className={classes.mapWrapper}>
                                    {navigator.onLine ?
                                        <MapWrapper
                                            googleMapURL={googleMapStringURL}
                                            loadingElement={<div style={{height: `100%`}}/>}
                                            containerElement={<div style={{height: `100%`}}/>}
                                            mapElement={<div style={{height: `100%`}}/>}
                                        /> : <div className={classes.noConnection}>Немає мережі</div>
                                    }
                                </div>

                                <div className={classes.searchButtonContainer}>
                                    {typeof punkts === "string"
                                        ? <div className={classes.errorMessage}>Вибачте, сталась помилка під час
                                            завантаження.</div>
                                        : <Departure border={true}/>}
                                </div>

                                {!punkts && <div><Loading/></div>}
                                {punkts && punkts.length === 0 &&
                                    <div className={classes.noPunkts}>Вибачте, немає пунктів для відображення.</div>}
                            </div>
                        </MapProvider>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions style={{display: 'flex', justifyContent: 'center', margin: '20px 0'}}>
                <SwipeStyledButton
                    animationStart={'right'}
                    animationMaterialColor={'#ff2121'}
                    buttonMaterialColor={'#ffffff'}
                    hoverTextColor={'#ffffff'}
                    border={"1px solid #0E4E4E"}
                    onClick={handleClose}
                >
                    СКАСУВАТИ
                </SwipeStyledButton>
                <SwipeStyledButton
                    animationStart={'right'}
                    buttonMaterialColor={'#FFC101'}
                    hoverTextColor={'#ffffff'}
                    onClick={handleConfirm}
                    style={{color: '#0E4E4E'}}
                >
                    ПІДТВЕРДИТИ
                </SwipeStyledButton>
            </DialogActions>
        </Dialog>
    );
}

function Map() {
    const coordinates = useContext(MapContext);
    const cl = useStyles();
    const dispatch = useDispatch();
    const isDesktopVersion = useMediaQuery('(min-width: 900px)') ? 0.2 : 0.7;
    const [open, setOpen] = useState(false);
    const zoomRef = useRef(null)
    const {selectPunkt} = useSelector(store => store.collectionPoints);
    const [changeZoom, setChangeZoom] = useState(false);
    const [zoom, setZoom] = useState(coordinates.showAllPunkts && !changeZoom ? 6 : 12);
    const [zomLat, setZomLat] = useState(zoom === 6 ? (zoom/12) + isDesktopVersion : ('0.0') + `${zoom / 12}`.replace('.', ''));

    function isEmptyObject(obj) {
        for (let i in obj) {
            if (obj.hasOwnProperty(i)) {
                return false;
            }
        }
        return true;
    }

    const MarkerWithPopper = ({punkt, coordinates}) => {
        const [selectedPunkt, setSelectedPunkt] = useState(false);

        const handleClick = (event) => {
            coordinates.setCheckNearest(punkt)
            event.stopPropagation();
            event.preventDefault();
            setOpen(punkt.id)
            setSelectedPunkt((prev) => !prev)
            setChangeZoom(true);
        };

        const handleSelectPunkt = (e) => {
            e.stopPropagation();
            e.preventDefault();
            setOpen(false)
            dispatch(getClientLocation(punkt))
            coordinates.setCheckNearest({})
            setChangeZoom(true);
        }
        //setCheckNearest

        useEffect(() => {
            if (coordinates.checkNearest && coordinates.checkNearest.id === punkt?.id) {
                setOpen(punkt?.id);
            } else {
                // setOpen(false)
            }
        }, [punkt, coordinates.checkNearest]);

        const handleClose = () => {
            coordinates.setCheckNearest({...coordinates.setCheckNearest, active: false})
            setOpen(false);
            setChangeZoom(false)
        }

        return (punkt && <OverlayView
            position={{lat: punkt.lat, lng: punkt.lng}}
            getPixelPositionOffset={getPixelPositionOffset}
            mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
            key={punkt.id+'marker'+(coordinates.checkNearest?.id || '')}
        >
            <div className={cl.markerWrapper}>
                {open === punkt.id && <div className={cl.popper}>
                    <div className={cl.popperAddressWrapper}>
                        <p className={cl.popperAddress}>{punkt.address && punkt.address}</p>
                        <IconButton onClick={handleClose} className={cl.popperMarkerCloseButton}><Close/></IconButton>
                    </div>
                    <TablePoints cl={cl} punkt={punkt}/>

                    {selectPunkt?.id !== punkt.id && !coordinates.inFrame && <div className={cl.SwipeStyledButton}>
                        <SwipeStyledButton
                            animationStart="left"
                            animationMaterialColor="#00B3A1"
                            buttonMaterialColor="#FFC101"
                            onClick={handleSelectPunkt}
                        >
                            Обрати
                        </SwipeStyledButton>
                    </div>}
                </div>}
                {(open === punkt.id || coordinates.checkNearest[punkt.id] || selectedPunkt || punkt?.id === coordinates.selectPunkt?.id)
                    ? <img src={locationActive} alt="locationActive" className={cl.markerImage}
                           onClick={(e) => handleClick(e)}/>
                    : <img src={Location} alt="location" className={cl.markerImage} onClick={(e) => handleClick(e)}/>
                }
            </div>
        </OverlayView>)
    }

    useEffect(() => {
        if (coordinates.showAllPunkts && !changeZoom) {
            setZoom(6);
            setZomLat((6 / 12)+ isDesktopVersion)
        } else {
            setZoom(12);
            setZomLat('0.0' + `${12 / 12}`.replace('.', ''));
        }
    }, [coordinates.showAllPunkts, changeZoom]);

    return (
        <GoogleMap
            defaultZoom={coordinates.showAllPunkts && !changeZoom ? 6 : 12}
            key={'centeredMap'+coordinates.showAllPunkts+coordinates.lat+coordinates.lon+changeZoom}
            ref={zoomRef}
            defaultCenter={{lat: +coordinates.lat, lon: coordinates.lon}}
            options={{
                streetViewControl: false,
                styles: [
                    {
                        elementType: "labels.icon",
                        stylers: [{visibility: "off"}],
                    },
                    {
                        elementType: "labels.text.fill",
                        stylers: [{color: "#616161"}],
                    },
                    {
                        elementType: "labels.text.stroke",
                        stylers: [{color: "#f5f5f5"}],
                    },
                    {
                        featureType: "poi",
                        elementType: "geometry",
                        stylers: [{color: "#eeeeee"}],
                    },
                    {
                        featureType: "poi",
                        elementType: "labels.text.fill",
                        stylers: [{color: "#757575"}],
                    },
                    {
                        featureType: "poi.park",
                        elementType: "geometry",
                        stylers: [{color: "#B9E4E4"}],
                    },
                    {
                        featureType: "landscape.natural",
                        elementType: "geometry",
                        stylers: [{color: "#e5e4e5"}],
                    },
                    {
                        featureType: "poi.park",
                        elementType: "labels.text.fill",
                        stylers: [{color: "#9e9e9e"}],
                    },
                    {
                        featureType: "road",
                        elementType: "geometry",
                        stylers: [{color: "#ffffff"}],
                    },
                    {
                        featureType: "road.arterial",
                        elementType: "labels.text.fill",
                        stylers: [{color: "#9e9e9e"}],
                    },
                    {
                        featureType: "road.highway",
                        elementType: "geometry",
                        stylers: [{color: "#FFFFFF"}],
                    },
                    {
                        featureType: "road.highway",
                        elementType: "labels.text.fill",
                        stylers: [{color: "#9e9e9e"}],
                    },
                    {
                        featureType: "road.local",
                        elementType: "labels.text.fill",
                        stylers: [{color: "#9e9e9e"}],
                    },
                    {
                        featureType: "transit.line",
                        elementType: "geometry",
                        stylers: [{color: "#ffffff"}],
                    },
                    {
                        featureType: "transit.station",
                        elementType: "geometry",
                        stylers: [{color: "#eeeeee"}],
                    },
                    {
                        featureType: "transit.station.rail",
                        elementType: "geometry",
                        stylers: [{color: "#ffffff"}],
                    },
                    {
                        featureType: "water",
                        elementType: "geometry",
                        stylers: [{color: "#c9c9c9"}],
                    },
                    {
                        featureType: "water",
                        elementType: "labels.text.fill",
                        stylers: [{color: "#9e9e9e"}],
                    },
                    {
                        featureType: "poi.attraction",
                        elementType: "geometry",
                        stylers: [{color: "#FEF6DD"}],
                    },
                    {
                        featureType: "poi.business",
                        elementType: "geometry",
                        stylers: [{color: "#FEF6DD"}],
                    },
                    {
                        featureType: "poi.government",
                        elementType: "geometry",
                        stylers: [{color: "#FEF6DD"}],
                    },
                    {
                        featureType: "poi.medical",
                        elementType: "geometry",
                        stylers: [{color: "#FEF6DD"}],
                    },
                    {
                        featureType: "poi.place_of_worship",
                        elementType: "geometry",
                        stylers: [{color: "#FEF6DD"}],
                    },
                    {
                        featureType: "poi.school",
                        elementType: "geometry",
                        stylers: [{color: "#FEF6DD"}],
                    },
                    {
                        featureType: "poi.sports_complex",
                        elementType: "geometry",
                        stylers: [{color: "#FEF6DD"}],
                    },
                ]
            }}
            onZoomChanged={() => {
                const currentZoom = zoomRef.current.getZoom()
                setZoom(currentZoom);
            }}
            center={!isEmptyObject(coordinates.checkNearest) && coordinates.checkNearest.active ?
                {
                    lat: +coordinates.checkNearest.lat + +zomLat + 0.0200000,
                    lng: +coordinates.checkNearest.lng,
                }
                : {
                    lat: +coordinates.checkNearest.lat + +zomLat + 0.0200000,
                    lng: +coordinates.lng
                }
            }
        >
            {coordinates.markers.length > 0 && typeof coordinates.markers !== "string" && coordinates.markers.map(punkt => (
                <MarkerWithPopper coordinates={coordinates} punkt={punkt} key={punkt.id}/>
            ))}
        </GoogleMap>
    );
}

const MapWrapper = withScriptjs(withGoogleMap(Map));

export default EditDepartmentDialog;